import React from "react";
import UserBillingCodOffsets from "../User/UserBillingCodOffsets";

// Every merchant's COD offsets (PD-2333). The same list is scoped to one merchant under
// User Details > Billing > COD Offsets.
const ContraReport = () => <UserBillingCodOffsets />;

export default ContraReport;
